import bg from 'date-fns/locale/bg/index.js';
import cs from 'date-fns/locale/cs/index.js';
import da from 'date-fns/locale/da/index.js';
import de from 'date-fns/locale/de/index.js';
import el from 'date-fns/locale/el/index.js';
import enGB from 'date-fns/locale/en-GB/index.js';
import enIN from 'date-fns/locale/en-IN/index.js';
import enUS from 'date-fns/locale/en-US/index.js';
import es from 'date-fns/locale/es/index.js';
import et from 'date-fns/locale/et/index.js';
import fi from 'date-fns/locale/fi/index.js';
import fr from 'date-fns/locale/fr/index.js';
import hr from 'date-fns/locale/hr/index.js';
import hu from 'date-fns/locale/hu/index.js';
import it from 'date-fns/locale/it/index.js';
import ja from 'date-fns/locale/ja/index.js';
import ko from 'date-fns/locale/ko/index.js';
import lt from 'date-fns/locale/lt/index.js';
import lv from 'date-fns/locale/lv/index.js';
import nl from 'date-fns/locale/nl/index.js';
import nn from 'date-fns/locale/nn/index.js';
import pl from 'date-fns/locale/pl/index.js';
import pt from 'date-fns/locale/pt/index.js';
import ptBR from 'date-fns/locale/pt-BR/index.js';
import ro from 'date-fns/locale/ro/index.js';
import ru from 'date-fns/locale/ru/index.js';
import sk from 'date-fns/locale/sk/index.js';
import sl from 'date-fns/locale/sl/index.js';
import sv from 'date-fns/locale/sv/index.js';
import uk from 'date-fns/locale/uk/index.js';
import zhCN from 'date-fns/locale/zh-CN/index.js';
import zhTW from 'date-fns/locale/zh-TW/index.js';

export const locale = {
  enGB,
  enUS,
  enIN,
  cs,
  da,
  de,
  el,
  es,
  et,
  fr,
  hr,
  it,
  lv,
  lt,
  hu,
  nl,
  nn,
  pl,
  pt,
  ptBR,
  ro,
  sl,
  sk,
  sv,
  fi,
  bg,
  ru,
  uk,
  ja,
  zhCN,
  zhTW,
  ko
};
